import { all } from "redux-saga/effects";
import cancelDeleteAccount from "./cancelDeleteAccount";
import deleteAccount from "./deleteAccount";
import getCheckTokenLogin from "./getCheckTokenLogin";
import getValidateLoginFaceId from "./getValidateLoginFaceId";
import postChangePassword from "./postChangePassword";
import postCreateNewPassword from "./postCreateNewPassword";
import postLogin from "./postLogin";
import postLogout from "./postLogout";
import postOffLoginWithFaceId from "./postOffLoginWithFaceId";
import postOnLoginWithFaceId from "./postOnLoginWithFaceId";
import postRegister from "./postRegister";
import postValidatePassword from "./postValidatePassword";
import checkRegisterDevice from "./checkRegisterDevice";
import approvedStatusDevice from "./approvedStatusDevice";

export const loginPageSaga = function* root() {
	yield all([
		cancelDeleteAccount(),
		deleteAccount(),
		getCheckTokenLogin(),
		getValidateLoginFaceId(),
		postChangePassword(),
		postCreateNewPassword(),
		postLogin(),
		postLogout(),
		postOffLoginWithFaceId(),
		postOnLoginWithFaceId(),
		postRegister(),
		postValidatePassword(),
		checkRegisterDevice(),
		approvedStatusDevice()
	]);
};
